<template>
    <flex-container :padding="Size.xl" justify-content="space-between">
        <flex-container :size="8">
            <text-heading>
                Artificial Intelligence
            </text-heading>
            <flex-container no-wrap>
                <text-description-icon-block :icon="SparklesIcon" />
                <text-description>
                    Je bevind je in het configuratiescherm voor A.I. . Hier kan jij de kunstmatige intelligentie voorzien van<br> informatie en configureren hoe jij wilt dat er ondersteuning wordt geboden.
                </text-description>
            </flex-container>
        </flex-container>
        <flex-container :size="2" justify-content="end">
            <button-block
                v-if="hasAISources"
                without-loading
                @completed="router.push({ name: 'settings-virtual-colleague-ai-rules-create' })"
            >
                Instructie aanmaken
            </button-block>
        </flex-container>
    </flex-container>

    <router-view />
</template>

<script setup lang="ts">
    import { Size, TextDescription, TextDescriptionIconBlock, TextHeading } from '@keyvue/one-ui';
    import SparklesIcon from '@assets/icons/Sparkles.svg?component';
    import { useRouter } from 'vue-router';
    import { computed } from 'vue';

    const router = useRouter();

    const hasAISources = computed(() => router.currentRoute.value.matched.some(
        (route) => route.name === 'settings-virtual-colleague-ai-rules',
    ));
</script>
